module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_05 (1).d3eb9f0b.png";